import { Collapse, Divider } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckIcon from '@mui/icons-material/Check';

import styles from '../styles.module.scss';
import { TTributeRecord } from 'api/http-client/types';
import { useState, useMemo } from 'react';
import { useTranslates } from 'providers/translates';
import { isVac } from "utilities/is-vac";
import { useAppSelector } from 'hooks';
import { Language } from 'providers/translates/enums';

interface IShowTributesProps {
  tributes: TTributeRecord[];
  editable?: boolean;
  deleteTributesAndCondolence: (id?: string) => void;
  toggleViewTributesAndCondolence: (id?: string) => void;
}

export const ShowTributes = ({
  tributes,
  editable,
  deleteTributesAndCondolence,
  toggleViewTributesAndCondolence,
}: IShowTributesProps) => {
  const [showAllTributes, setShowAllTributes] = useState(false);
  const { translates } = useTranslates();
  const transl = translates?.tributesAndCondolences;
  const editorData = useAppSelector((state) => state.quilt.editableQuilt);
  const isFrench = editorData.lang === Language.FRENCH;


  const reversedTributes = useMemo(() => [...tributes].reverse(), [tributes]);

  if (isVac()) {
    return (
      <div className={styles.tributes}>
        <h2 className={styles.title}>{isFrench ? 'Messages, souvenirs et saluts' : 'Messages, Memories, and Salutes'}</h2>
        {reversedTributes.length > 0 ? (
          <>
            
            {reversedTributes.slice(0, 3).map((record) => (
              <span key={record.id}>
                <div className={styles.record}>
                  <div className={styles.imgWrapper}>
                    {(!record?.icon || record?.icon === 'none') ? null : (
                      <img
                        className={styles.icon}
                        src={record?.icon || ''}
                        alt={'Image'}
                      />
                    )}
                  </div>
                  <div className={styles.textBox}>
                    <h3>{`${record.firstName} ${record.lastName}`}</h3>
                    <i>{record.message}</i>
                  </div>
                  {editable && (
                    <div className={styles.iconsBlock}>
                      <div
                        className={styles.delete}
                        onClick={() => deleteTributesAndCondolence(record.id)}
                      >
                        <DeleteOutlineIcon />
                      </div>
                      {!record.isApproved && (
                        <div
                          className={styles.view}
                          onClick={() => toggleViewTributesAndCondolence(record.id)}
                        >
                          <CheckIcon />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <Divider />
              </span>
            ))}

            
            <Collapse in={showAllTributes} timeout={700}>
              {reversedTributes.slice(3).map((record) => (
                <span key={record.id}>
                  <div className={styles.record}>
                    <div className={styles.imgWrapper}>
                      {record?.icon === 'none' || !record?.icon ? null : (
                        <img
                          className={styles.icon}
                          src={record.icon || ''}
                          alt={'Image'}
                        />
                      )}
                    </div>
                    <div className={styles.textBox}>
                      <h3>{`${record.firstName} ${record.lastName}`}</h3>
                      <i>{record.message}</i>
                    </div>
                    {editable && (
                      <div className={styles.iconsBlock}>
                        <div
                          className={styles.delete}
                          onClick={() => deleteTributesAndCondolence(record.id)}
                        >
                          <DeleteOutlineIcon />
                        </div>
                        {!record.isApproved && (
                          <div
                            className={styles.view}
                            onClick={() => toggleViewTributesAndCondolence(record.id)}
                          >
                            <CheckIcon />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <Divider />
                </span>
              ))}
            </Collapse>
          </>
        ) : (
          <p>{isFrench ? 'Les messages apparaîtront ici.' : 'Messages will appear here.'}</p>
        )}

        {/* Кнопка "Показать больше" */}
        {reversedTributes.length > 3 && (
          <div className={styles.loadMore}>
            <button
              className={`customButton ${styles.btn}`}
              onClick={() => setShowAllTributes((show) => !show)}
            >
              {showAllTributes ? (
                <>
                  {isFrench ? 'Afficher moins' : 'Show Less'}{' '}
                  <ArrowDropUpIcon className={styles.actionArow} fontSize={'large'} sx={{ color: '#1D486F' }} />
                </>
              ) : (
                <>
                  {isFrench ? 'Voir plus' : 'Load More'}{' '}
                  <ArrowDropDownIcon className={styles.actionArow} fontSize={'large'} sx={{ color: '#1D486F' }} />
                </>
              )}
            </button>
          </div>
        )}
      </div>
    );
  }
    
  return (
    <div className={styles.tributes}>
      <h2 className={styles.title}>{transl?.title ?? 'Tributes and Condolences'}</h2>

      {reversedTributes.length > 0 ? (
        <>
          
          {reversedTributes.slice(0, 3).map((record) => (
            <span key={record.id}>
              <div className={styles.record}>
                <div className={styles.imgWrapper}>
                  {(!record?.icon || record?.icon === 'none') ? null : (
                    <img
                      className={styles.icon}
                      src={record?.icon || ''}
                      alt={transl?.title ?? 'Tributes and Condolences'}
                    />
                  )}
                </div>
                <div className={styles.textBox}>
                  <h3>{`${record.firstName} ${record.lastName}`}</h3>
                  <i>{record.message}</i>
                </div>
                {editable && (
                  <div className={styles.iconsBlock}>
                    <div
                      className={styles.delete}
                      onClick={() => deleteTributesAndCondolence(record.id)}
                    >
                      <DeleteOutlineIcon />
                    </div>
                    {!record.isApproved && (
                      <div
                        className={styles.view}
                        onClick={() => toggleViewTributesAndCondolence(record.id)}
                      >
                        <CheckIcon />
                      </div>
                    )}
                  </div>
                )}
              </div>
              <Divider />
            </span>
          ))}
          
          <Collapse in={showAllTributes} timeout={700}>
            {reversedTributes.slice(3).map((record) => (
              <span key={record.id}>
                <div className={styles.record}>
                  <div className={styles.imgWrapper}>
                    {record?.icon === 'none' || !record?.icon ? null : (
                      <img
                        className={styles.icon}
                        src={record.icon || ''}
                        alt={transl?.title ?? 'Tributes and Condolences'}
                      />
                    )}
                  </div>
                  <div className={styles.textBox}>
                    <h3>{`${record.firstName} ${record.lastName}`}</h3>
                    <i>{record.message}</i>
                  </div>
                  {editable && (
                    <div className={styles.delete} onClick={() => deleteTributesAndCondolence(record.id)}>
                      <DeleteOutlineIcon />
                    </div>
                  )}
                </div>
                <Divider />
              </span>
            ))}
          </Collapse>
        </>
      ) : (
        <p>{transl?.noRecords ?? 'Messages will appear here.'}</p>
      )}
      {reversedTributes.length > 3 && (
        <div className={styles.loadMore}>
          <button
            className={`customButton ${styles.btn}`}
            onClick={() => setShowAllTributes((show) => !show)}
          >
            {showAllTributes ? (
              <>
                {transl?.showLess ?? 'Show Less'}{' '}
                <ArrowDropUpIcon className={styles.actionArow} fontSize={'large'} sx={{ color: '#1D486F' }} />
              </>
            ) : (
              <>
                {transl?.showMore ?? 'Load More'}{' '}
                <ArrowDropDownIcon className={styles.actionArow} fontSize={'large'} sx={{ color: '#1D486F' }} />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
};